module.exports = __webpack_public_path__ + "static/media/5.60a44626.jpg";